import Layout from "@/components/Layout";

export default function About() {
  return (
    <Layout>
      <section className="mx-auto max-w-6xl px-4 sm:px-8 py-16">
        <div className="eyebrow mb-2">About</div>
        <h1 className="hero-title text-4xl sm:text-5xl text-white">Local shop. Real specs. Fast turn.</h1>
        <div className="mt-8 grid md:grid-cols-2 gap-10">
          <div>
            <p className="text-slate-300 leading-relaxed">
              Childress Hydraulics is a small, owner-run shop out of Greensburg, KY (42743).
              We rebuild hydraulic cylinders for farmers, excavation crews, loggers, and anyone
              running heavy iron between Louisville and Bowling Green.
            </p>
            <p className="mt-4 text-slate-300 leading-relaxed">
              We measure every cylinder that comes in the door — bore, rod, stroke, pin-to-pin —
              so we're not chasing you for numbers later. On the phone or on-site, our number is
              <span className="text-red-500 font-semibold"> 270-405-4083</span>.
            </p>

            <div className="mt-8 grid grid-cols-2 gap-6">
              <div>
                <div className="eyebrow">Service Area</div>
                <div className="font-display font-black text-3xl text-white mt-1">50 MILES</div>
                <div className="text-slate-400 text-sm">From Greensburg, KY</div>
              </div>
              <div>
                <div className="eyebrow">Rate</div>
                <div className="font-display font-black text-3xl text-white mt-1">$75 / HR</div>
                <div className="text-slate-400 text-sm">On-site • 2 hr minimum</div>
              </div>
            </div>
          </div>

          <div className="shop-card p-2 overflow-hidden">
            <ServiceAreaMap />
          </div>
        </div>
      </section>
    </Layout>
  );
}

function ServiceAreaMap() {
  // Static OSM tile centered around 42743 with a red circle overlay showing the 50-mile radius.
  return (
    <div className="w-full h-[420px] relative">
      <iframe
        title="Service Area Map"
        className="w-full h-full rounded-sm"
        loading="lazy"
        src="https://www.openstreetmap.org/export/embed.html?bbox=-88.0,35.9,-83.0,38.6&layer=mapnik&marker=37.2617,-85.4914"
      />
      <div className="absolute inset-0 pointer-events-none flex items-center justify-center">
        <div className="w-40 h-40 sm:w-52 sm:h-52 rounded-full border-2 border-red-500/70 bg-red-500/10" />
      </div>
      <div className="absolute bottom-2 left-2 bg-black/80 text-white text-xs px-3 py-1 rounded-sm font-mono-tech">
        50 mile radius • Greensburg, KY 42743
      </div>
    </div>
  );
}
